var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCasa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7141 14.9863L21.9524 9.28319C21.5709 8.9056 20.9525 8.9056 20.5713 9.28319L18.3809 11.4511L16.1907 9.28319C15.8092 8.9056 15.1908 8.9056 14.8095 9.28319L12.6191 11.4511L10.4287 9.28319C10.0475 8.9056 9.4291 8.9056 9.04782 9.28319L3.2861 14.9863C3.10281 15.1675 3 15.4134 3 15.6697V27.0759C3 27.6099 3.43716 28.0426 3.97656 28.0426H27.0234C27.5628 28.0426 28 27.6099 28 27.0759V15.6697C28 15.4134 27.8972 15.1675 27.7141 14.9863ZM15.5 11.3337L20.2852 16.0702V26.1093H16.4766V15.6697C16.4766 15.4133 16.3738 15.1675 16.1907 14.9863L14.0003 12.8182L15.5 11.3337ZM9.73828 11.3337L4.95312 16.0702V26.1093H6.84121V21.3728C6.84121 20.8389 7.27837 20.4062 7.81777 20.4062H11.659C12.1984 20.4062 12.6355 20.8389 12.6355 21.3728V26.1093H14.5234V16.0702L9.73828 11.3337ZM10.6826 26.1093H8.7945V22.3394H10.6826V26.1093ZM22.2383 26.1093H26.0469V16.0702L21.2617 11.3337L19.762 12.8182L21.9524 14.9863C22.1355 15.1675 22.2383 15.4133 22.2383 15.6697V26.1093Z",
    fill: "#14B497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasa);
export default __webpack_public_path__ + "static/media/casa.ea1183dbe2af414336be475fdf2f2975.svg";
export { ForwardRef as ReactComponent };